/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "zesgxhystdgptupkmrdd"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inplc2d4aHlzdGRncHR1cGttcmRkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2NDY3MDUsImV4cCI6MjA3MjIyMjcwNX0.zU0lf3zriHZFp6XHaYSKc5UTYjwOSf979ZpGUmL1Pi0"